/** 
*@author: Sirisha.M
*@Description : 
**/
import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import { connect } from 'react-redux';

import themeSettings from '../../../commons/styles/themeSettings.json';
import Attributes from '../Masters/Attributes';
import Parameter from '../Masters/Parameter';
import translation from '../Utils/translation';

const { TabPane } = Tabs;

const DeviceTypes = (props) => {
  const [presentActiveKey, setPresentActiveKey] = useState('Parameter');
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    // Handle translation cache updates if needed
  }, [translationCache]);

  const searchParams = new URLSearchParams(props.location?.search);
  const newParams = Object.fromEntries([...searchParams]);

  return (
    <div style={{ minHeight: window.innerHeight - 69 }}>
      <Tabs
        tabPosition="top"
        type="card"
        style={{ marginBottom: '30px' }}
        theme={themeSettings}
        defaultActiveKey="Parameter"
        activeKey={presentActiveKey}
        onChange={(activeKey) => {
          setPresentActiveKey(activeKey || 'Parameter');
        }}
      >
        <TabPane tab={translation(translationCache, 'Parameter')} key="Parameter">
          <Parameter type={newParams.type} />
        </TabPane>
        <TabPane tab={translation(translationCache, 'Attributes')} key="Attributes">
          <Attributes type={newParams.type} />
        </TabPane>
      </Tabs>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(DeviceTypes);
